<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <strong v-if="!subuser.passwordExpired">Cambio password</strong>
        <strong v-if="subuser.passwordExpired">Cambio password obbligatorio</strong>
      </div>
      <b-form-group>
        <label for="oldPassword">Password attuale</label>
        <b-form-input v-model="oldPassword" type="password" id="oldPassword" placeholder></b-form-input>
        <b-form-invalid-feedback
          :force-show="errors.oldPassword"
        >Occorre inserire la vecchia password</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <label for="newPassword">Nuova password</label>
        <b-form-input v-model="newPassword" type="password" id="newPassword" placeholder></b-form-input>
        <b-form-invalid-feedback
          :force-show="errors.newPassword"
        >La password deve essere lunga almeno 8 caratteri e deve contenere almeno 1 carattere minuscolo, 1 carattere maiuscolo, 1 numero e un carattere speciale</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <label for="newPasswordConfirmation">Conferma password</label>
        <b-form-input
          v-model="newPasswordConfirmation"
          type="password"
          id="newPasswordConfirmation"
          placeholder
        ></b-form-input>
        <b-form-invalid-feedback
          :force-show="errors.newPasswordConfirmation"
        >Le password devono corrispondere</b-form-invalid-feedback>
      </b-form-group>
      <div slot="footer">
        <b-button :disabled="loading" type="submit" @click="changePwd" variant="primary">
          <i v-if="loading" class="fa fa-spinner fa-pulse fa-fw"></i>
          <i v-else class="fa fa-lock"></i> Cambia
        </b-button>
        <span v-if="success" class="text-success">&nbsp;Password cambiata con successo!</span>
        <span
          v-if="errors.submit"
          class="text-danger"
        >&nbsp;Errore durante il cambio password, password attuale errata</span>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "change-pwd",
  data() {
    return {
      errors: {
        oldPassword: false,
        newPassword: false,
        newPasswordConfirmation: false,
        submit: false
      },
      success: false,
      loading: false,
      oldPassword: "",
      newPassword: "",
      newPasswordConfirmation: ""
    };
  },
  computed: {
    ...mapGetters(["subuser"])
  },
  methods: {
    changePwd: function() {
      if (!this.checkForm()) {
        return;
      }

      this.loading = true;
      this.$store
        .dispatch("changepwd", {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        })
        .then(() => {
          console.log("password changed");
          this.oldPassword = "";
          this.newPassword = "";
          this.newPasswordConfirmation = "";
          this.success = true;
        })
        .catch(err => {
          console.log("error");
          this.errors.submit = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkForm: function() {
      const strongRegex = new RegExp(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_])(?=.{8,})"
      );

      this.success = false;
      this.errors.submit = false;

      if (!this.oldPassword) {
        this.errors.oldPassword = true;
        return false;
      } else {
        this.errors.oldPassword = false;
      }

      if (!this.newPassword || !strongRegex.test(this.newPassword)) {
        this.errors.newPassword = true;
        return false;
      } else {
        this.errors.newPassword = false;
      }

      if (this.newPassword != this.newPasswordConfirmation) {
        this.errors.newPasswordConfirmation = true;
        return false;
      } else {
        this.errors.newPasswordConfirmation = false;
      }

      return true;
    }
  }
};
</script>
